import { useEffect, useState } from 'react';
import { ToastContainer, ToastMessage, ToastWrapper } from './ToastStyling';

interface ToastProps {
    message: string;
    type?: 'error' | 'success' | 'info';
    duration?: number;
    onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({ 
    message, 
    type = 'error', 
    duration = 3000,
    onClose 
}) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onClose?.();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!isVisible) return null;

    return (
        <ToastContainer>
            <ToastWrapper type={type}>
                <ToastMessage>{message}</ToastMessage>
            </ToastWrapper>
        </ToastContainer>
    );
};

export default Toast; 